import MdHighlightText from "./MdHighlightText"

const MdHighlightTextPlugin = {
  install(app) {
    app.component(MdHighlightText.name, MdHighlightText)
  },
}

export default MdHighlightTextPlugin
